"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectColony = void 0;
var vue_1 = require("vue");
var Colony_1 = require("./Colony");
var Button_1 = require("../components/common/Button");
var TranslateMixin_1 = require("./TranslateMixin");
exports.SelectColony = vue_1.default.component('select-colony', {
    props: {
        playerinput: {
            type: Object,
        },
        onsave: {
            type: Function,
        },
        showsave: {
            type: Boolean,
        },
        showtitle: {
            type: Boolean,
        },
    },
    mixins: [TranslateMixin_1.TranslateMixin],
    data: function () {
        return {
            selectedColony: undefined,
        };
    },
    components: {
        'colony': Colony_1.Colony,
        'Button': Button_1.Button,
    },
    methods: {
        saveData: function () {
            var result = [];
            result.push([]);
            if (this.selectedColony !== undefined) {
                result[0].push(this.selectedColony);
            }
            this.onsave(result);
        },
    },
    template: "<div class=\"wf-component wf-component--select-card\">\n        <div v-if=\"showtitle === true\" class=\"nofloat wf-component-title\">{{ $t(playerinput.title) }}</div>\n        <label v-for=\"colony in (playerinput.coloniesModel || [])\" class=\"cardbox\" :key=\"colony.name\">\n            <input type=\"radio\" v-model=\"selectedColony\" :value=\"colony.name\" />\n            <colony :colony=\"colony\"></colony>\n        </label>\n        <div v-if=\"showsave === true\" class=\"nofloat\">\n            <Button :onClick=\"saveData\" :title=\"playerinput.buttonLabel\" /> \n        </div>\n    </div>",
});
//# sourceMappingURL=SelectColony.js.map